(function() {
    'use strict';
    angular
        .module('eDocumentsApp')
        .factory('InvoiceLine', InvoiceLine);

    InvoiceLine.$inject = ['$resource', 'DateUtils'];

    function InvoiceLine ($resource, DateUtils) {
        var resourceUrl =  'api/invoice-lines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lotValidUntil = DateUtils.convertLocalDateFromServer(data.lotValidUntil);
                        data.deliveryDate = DateUtils.convertLocalDateFromServer(data.deliveryDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.lotValidUntil = DateUtils.convertLocalDateToServer(copy.lotValidUntil);
                    copy.deliveryDate = DateUtils.convertLocalDateToServer(copy.deliveryDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.lotValidUntil = DateUtils.convertLocalDateToServer(copy.lotValidUntil);
                    copy.deliveryDate = DateUtils.convertLocalDateToServer(copy.deliveryDate);
                    return angular.toJson(copy);
                }
            },
            'omniboxSearch': {
                method: 'GET',
                isArray: true,
                url: 'api/invoice-lines/omniboxSearch'
            }
        });
    }
})();
